<template>
  <div>
    <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>
    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <!-- Initial Loading -->
    <div v-if="pageLoading" class="text-center py-5">
      <b-spinner variant="primary" label="Loading..." style="width: 3rem; height: 3rem;"></b-spinner>
      <p class="mt-3 h5">Loading Expense Type information...</p>
    </div>

    <!-- Main Form -->
    <b-card v-else>
      <b-row>
        <div class="col-12 mt-3">
          <b-form @submit.prevent="updateExpenseType" v-if="show">
            <!-- Heading -->
            <div style="background-color:#617498; height:32px; border-radius:4px;">
              <h4 style="color:#dfe3ee; margin-left:5px; font-weight:bold;">
                Update Expense Type
              </h4>
            </div>

            <div class="row">
              <!-- Expense Type Name -->
              <div class="col-md-6 col-12">
                <b-form-group label="Expense Type Name:" label-for="name">
                  <b-form-input
                    id="name"
                    v-model="expenseType.name"
                    placeholder="Enter expense type name"
                    :state="validateField(expenseType.name)"
                    required
                  />
                </b-form-group>
              </div>
            </div>

            <!-- Submit -->
            <b-button type="submit" variant="primary" class="mb-3" :disabled="isLoading">
              <span v-if="!isLoading">Update</span>
              <b-spinner v-else small></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import axios from "@/axios";

export default {
  data() {
    return {
      show: true,
      pageLoading: true, 
      isLoading: false,
      successMessage: "",
      errorMessage: "",

      expenseType: {
        id: null,
        name: "",
      },
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BSpinner,
  },
  created() {
    this.fetchExpenseType();
  },
  methods: {
        validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
    async fetchExpenseType() {
      const id = this.$route.params.id;
      try {
        const res = await axios.get(`/expenseTypes/${id}`);
        const data = res.data.data;
        this.expenseType.id = data.id;
        this.expenseType.name = data.name;
      } catch (err) {
        this.errorMessage = "Expense Type details not found.";
      } finally {
        this.pageLoading = false; // hide loader when done
      }
    },
    updateExpenseType() {
      this.isLoading = true;

      const formData = new FormData();
      formData.append("name", this.expenseType.name);

      axios
        .post(`/expenseTypesUpdate/${this.expenseType.id}`, formData)
        .then(() => {
          this.$bvToast.toast("Expense Type updated successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.$router.push({ name: "ListExpenseTypes" });
        })
        .catch(() => {
          this.errorMessage = "Error updating expense type.";
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
